import { MedalMilitaryIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Medal = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <MedalMilitaryIcon {...rest} size={Sizes[size]} color={fill} />;
};

Medal.displayName = 'Medal';
